import React from 'react'
import everestSDK from 'everest-sdk'

const App = () => {
	const options = {
		env: "production",
		appKey: "nde0DcynPxi6MKm",
		widgetWidth: "100%",
		widgetHeight: "100%"
	};
	return everestSDK.initialize(options);
};

export default App
